import type { UnitIdInExperiment } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { X } from "lucide-react";

interface UnitIdInExperimentFilterProps {
  value: UnitIdInExperiment;
  onChange: (value: UnitIdInExperiment) => void;
}

export function UnitIdInExperimentFilter({ value, onChange }: UnitIdInExperimentFilterProps) {
  const addVariationId = () =>
    onChange({ ...value, variation_ids: [...value.variation_ids, 0] });
  const updateVariationId = (i: number, v: number) => {
    const next = [...value.variation_ids];
    next[i] = v;
    onChange({ ...value, variation_ids: next });
  };
  const removeVariationId = (i: number) =>
    onChange({ ...value, variation_ids: value.variation_ids.filter((_, j) => j !== i) });

  return (
    <div className="space-y-3">
      <div>
        <Label className="mb-1 block text-xs">Experiment ID</Label>
        <Input
          value={value.experiment_id}
          onChange={(e) => onChange({ ...value, experiment_id: e.target.value })}
          placeholder="experiment_id"
        />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label className="text-xs">Variation IDs</Label>
          <Button type="button" variant="outline" size="sm" onClick={addVariationId}>
            Add ID
          </Button>
        </div>
        {value.variation_ids.map((vid, i) => (
          <div key={i} className="flex items-center gap-2">
            <Input
              type="number"
              value={vid}
              onChange={(e) => updateVariationId(i, parseInt(e.target.value) || 0)}
              className="w-24"
            />
            <Badge variant="secondary" className="text-[10px]">
              variation {i}
            </Badge>
            <Button type="button" variant="ghost" size="icon" onClick={() => removeVariationId(i)}>
              <X className="h-4 w-4 text-red" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
